import {ColumnsType} from "antd/es/table";

const GlassesPrescriptionColumns: ColumnsType = [
  {
    title: "-",
    dataIndex: "none",
    align: "center",
  },

  {
    title: "Cầu",
    dataIndex: "sph",
    align: "center",
  },
  {
    title: "Trụ",
    dataIndex: "cyl",
    align: "center",
  },
  {
    title: "Trục",
    dataIndex: "axis",
    align: "center",
  },
  {
    title: "Thị lực",
    dataIndex: "vision",
    align: "center",
  },
];
const data4Col = [
  {
    key: 1,
    none: "Xa",
    sph: "",
    cyl: "",
    axis: "",
    vision: null,
  },
  {
    key: 2,
    none: "Add",
    sph: "",
    cyl: "",
    axis: "",
    vision: null,
  },
  {
    key: 3,
    none: "Gần",
    sph: "",
    cyl: "",
    axis: "",
    vision: null,
  },
];
export {GlassesPrescriptionColumns, data4Col};
